import React from "react";

type VaultContextType = any;

const VaultContext = React.createContext<VaultContextType | null>(null);

/**
 * Hook for getting vault information from the vault context.  Currently holds
 * both the app state and all helper functions used to interface with the vault
 * and vault actions.  In the future we may want to partition this into several
 * contexts.  Or maybe two to parallel withVaultUpdate and withVaultDispatch.
 *
 * Not currently used.
 *
 * @returns Vault instance or null if not found
 */
export const useVault = (): VaultContextType | null => {
	return React.useContext(VaultContext);
};

export const useVaultDispatch = () => {
	const vault = useVault();
	if (!vault) {
		return null;
	}
	return vault.dispatch;
};

/**
 * Hook to directly access the vault state.
 *
 * Currently triggers a rerender every time the vault state changes, which is
 * not ideal for performance for most use cases.
 * TODO: Add a hook parallel to withVaultUpdate allowing the caller to subscribe to
 * part of the vault state.  This is a bit involved and probably involves a bit of
 * additional consideration regarding what our ideal API looks like.
 *
 * @returns Vault state or null if not found
 */
export const useVaultState = () => {
	const vault = useVault();
	const [state, setState] = React.useState(vault?.getState());
	React.useEffect(() => {
		const callback = () => {
			setState(vault.getState());
		};
		vault?.on("update", callback);
		return () => {
			vault?.off("update", callback);
		};
	}, [vault]);
	if (!vault) {
		return null;
	}
	return state;
};

export default VaultContext;
